<template>
  <el-table-column label="照片" width="80">
    <template v-slot="{row}">
      <el-popover placement="left" width="300" trigger="hover" popper-class="photo">
        <img :src="row.photo">
        <img :src="row.photo" slot="reference">
      </el-popover>
    </template>
  </el-table-column>
</template>

<script>
export default {
  props: {
    photo: {
      type: String
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
.el-popover.photo {
  img {
    width: 100%;
  }
}
</style>
